import React from 'react';
import Modal from 'react-modal';
import './Notices.css';

const Notices = ({ isOpen, onRequestClose, selectedNotice }) => {
  if (!selectedNotice) return null;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Notice"
      className="notices-modal"
      overlayClassName="notices-modal-overlay"
    >
      <div className="notices-modal-content">
        <button onClick={onRequestClose} className="notices-close-modal-button">Close</button>
        <h2 className="notices-modal-title">{selectedNotice.title}</h2>
        <div
          className="notices-content"
          dangerouslySetInnerHTML={{ __html: selectedNotice.content }}
        />
      </div>
    </Modal>
  );
};

export default Notices;